import {
  SR_API_ACTION_HOUSEHOLD_APPLICATION_SUBMISSION_MARK_RENTER_REQUIREMENTS,
} from 'api/actionTypes';

import updateLocalApplicationSubmission from 'client/actions/HouseholdApplicationSubmission/updateLocalApplicationSubmission';

export default async function markRenterRequirements({ state, apiClient }, { applicationSubmissionId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_APPLICATION_SUBMISSION_MARK_RENTER_REQUIREMENTS,
    state: state,
    payload: {
      applicationSubmissionId,
    },
    onSuccess() {
      updateLocalApplicationSubmission({ state }, {
        applicationSubmissionId,
        updates: { agreeRenterRequirements: true },
      });
    },
  });
}
